import { useMemo } from "react";
import Slider from "react-slick";

const teamLogos = [
  "/assets/home/grocery-brand1.webp",
  "/assets/home/grocery-brand2.webp",
  "/assets/home/grocery-brand3.webp",
  "/assets/home/grocery-brand4.webp",
  "/assets/home/grocery-brand5.webp",

  
];

export default function GroceryLogos({heading=false, newClass=""}) {

 const settings2 = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    slidesToShow: 6,
    slidesToScroll: 1,
    pauseOnHover: false,
    swipe: false,
    draggable: false,
    touchMove: false,
    responsive: [
      {
        breakpoint: 991,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 767,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 599,
        settings: { slidesToShow: 3 },
      },
    ],
  };


  return (
    <section className={`Lyft-teamlogo grocery-team-logo ${newClass}`}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {heading && (
              <span className="team-logo-dynamic-head">Teamed up with awesome brands through the years.</span>
            )}
            <Slider className="teamlogo-slider" {...settings2}>
              {teamLogos.map((logo, index) => (
                <div key={index} className="teamlogo-box Lyft-teamlogo-box">
                  <div>
                    <img width="240" height="100" src={logo} alt={`team logo ${index + 1}`} loading="lazy"/>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
}
